import { render, staticRenderFns } from "./OrderPaymentStatusUploadHistory.vue?vue&type=template&id=4a0afa64&scoped=true&"
import script from "./OrderPaymentStatusUploadHistory.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentStatusUploadHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaymentStatusUploadHistory.vue?vue&type=style&index=0&id=4a0afa64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0afa64",
  null
  
)

export default component.exports